<template>
  <div style="width: 100%">
    <v-card
      width="100%"
      elevation="0"
      color="#f1f2f3"
      v-show="!$vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.mdAndUp"
    >
      <v-row no-gutters class="seat-header" align="center">
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
          class="px-4 pt-3"
        >
          <v-btn icon fab class="mr-4 recenter-btn" @click="resetZoom">
            <v-img
              flat
              src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/re-center.svg"
            ></v-img>
          </v-btn>

          <v-btn
            class="add-remove-button ml-2"
            @click="onZoomIn"
            outlined
            small
            fab
            icon
            color="secondary"
          >
            <v-icon class="add-remove-button__icon" color="primary"
              >mdi-plus</v-icon
            >
          </v-btn>

          <v-btn
            class="add-remove-button mx-6"
            @click="onZoomOut"
            outlined
            small
            fab
            color="secondary"
          >
            <v-icon size="30" class="add-remove-button__icon">mdi-minus</v-icon>
          </v-btn>

          <b style="">{{ selectedSector.nome }}</b>
        </v-col>
        <v-spacer></v-spacer>

        <Subtitle v-if="$vuetify.breakpoint.mdAndUp" />
      </v-row>

      <panZoom
        v-if="listSeats && listSeats.length > 1"
        id="panz"
        @init="onInit"
        style="overflow: hidden; outline: none !important; cursor: move"
        :options="{
          minZoom: !$vuetify.breakpoint.mdAndUp ? 0.4 : 0.7,
          maxZoom: 4,
          zoomSpeed: $vuetify.breakpoint.mdAndUp ? 0.195 : 0.04,
          pinchSpeed: 0.01,
          zoomDoubleClickSpeed: 1,
          bounds: !$vuetify.breakpoint.mdAndUp ? true : false,
          boundsPadding: 0.1,
        }"
      >
        <div
          id="seatmap"
          :style="$route.query.sectorMode ? 'max-height: 75vh' : ''"
          class="noselect"
        >
          <v-tooltip
            top
            v-for="seat in formattedMap"
            :key="seat.codigo_obj"
            color="#192B46"
            bottom
            class="selecting"
            :disabled="!seat.codigo_assento"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                :id="seat.codigo_obj"
                v-bind="attrs"
                v-on="on"
                :class="`${checkObjectClass(seat)}`"
                :style="validateStyle(seat)"
                v-my-touch="
                  seat.identificacao &&
                  seat.disponivel &&
                  !(seat.tipo === '9' && !seat.produto_vinculado)
                    ? setSeatToSelect
                    : handleShowError
                "
              >
                <div
                  :id="seat.codigo_obj"
                  class="seat-number"
                  v-if="
                    seat.identificacao &&
                    seat.class !== 'cadeiraDefici2' &&
                    seat.class !== 'cadeiraDefici1' &&
                    !seat.selecionado
                  "
                  :style="
                    seat.class === 'espaco' ? 'font-size: 20px !important' : ''
                  "
                >
                  {{ getIdentification(seat) }}
                </div>
                <div
                  :id="seat.codigo_obj"
                  class="seat-number"
                  v-if="seat.selecionado"
                >
                  <v-icon small color="#192b46" class="selecting"
                    >mdi-check</v-icon
                  >
                </div>
                <div
                  class="identificacao"
                  v-if="
                    seat.class === 'elementoIdent' &&
                    seat.descricao !== 'Indisponível'
                  "
                  v-html="seat.descricao"
                ></div>
                <div
                  v-if="
                    seat.descricao &&
                    seat.class !== 'elementoIdent' &&
                    seat.descricao !== 'Indisponível' &&
                    seat.tipo !== '9'
                  "
                  class="seat-number"
                  :class="
                    seat.descricao === 'palco'
                      ? 'palco ident-palco'
                      : 'ident-palco'
                  "
                  :style="`${
                    getSpecificStyle(seat.style, 'color')
                      ? `color: ${getSpecificStyle(
                          seat.style,
                          'color'
                        )} !important; `
                      : ''
                  }${
                    getSpecificStyle(seat.style, 'font-size')
                      ? `font-size: ${getSpecificStyle(
                          seat.style,
                          'font-size'
                        )} !important; `
                      : ''
                  }`"
                  v-html="seat.descricao"
                ></div>
                <div
                  :id="seat.codigo_obj"
                  class="seat-number"
                  v-if="
                    (seat.class === 'cadeiraDefici2' ||
                      seat.class === 'cadeiraDefici1') &&
                    !seat.selecionado
                  "
                >
                  <v-icon class="seat-cadeirante selecting"
                    >mdi-wheelchair</v-icon
                  >
                </div>
                <div
                  class="seat-number"
                  v-if="
                    (seat.class === 'cadeiraDefici2' ||
                      seat.class === 'cadeiraDefici1') &&
                    seat.selecionado
                  "
                >
                  <v-icon class="selecting" small>mdi-check</v-icon>
                </div>
              </span>
            </template>
            <tooltip-content :seat="seat"></tooltip-content>
          </v-tooltip>
        </div>
      </panZoom>
      <div v-else>Indisponível</div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Subtitle from "./Subtitle.vue";
import TooltipContent from "./TooltipContent.vue";
export default {
  components: { Subtitle, TooltipContent },
  props: ["listSeats"],

  data() {
    return {
      seats: [],
      panInst: null,
      panId: null,
      pzx: null,
      pzy: null,
      mapSize: 800,
      isDrag: false,
      timeoutDrag: false,
    };
  },
  beforeCreate() {
    setTimeout(this.validateUserSeats, 1000);
  },

  computed: {
    ...mapGetters(["selectedSeat", "selectedSector", "cartProducts"]),
    formattedMap() {
      let array = [];
      if (this.listSeats && this.listSeats.length) {
        this.listSeats.forEach((seat) => {
          array.push(seat);
          if (seat.identificacao.includes("MESA")) {
            const isRetangularTable = this.checkIfIsRectangularTable(seat);

            if (!isRetangularTable) {
              let number = Number(
                seat.identificacao.replace("MESA", "").split("-")[0]
              );
              for (let i = 0; i < number; i++) {
                let copy = JSON.parse(JSON.stringify(seat));
                let splittedStyle = seat.style.split("; ");
                let topStyle = 0;
                let leftStyle = 0;
                let size = 0;
                splittedStyle.forEach((style) => {
                  if (style.includes("top"))
                    topStyle = Number(style.split(" ")[1].replace("px", ""));
                  if (style.includes("left"))
                    leftStyle = Number(style.split(" ")[1].replace("px", ""));
                  if (style.includes("width"))
                    size = Number(style.split(" ")[1].replace("px", ""));
                });
                copy.style = `${this.getStyleCircle(
                  i + 1,
                  number,
                  size,
                  topStyle,
                  leftStyle
                )} background-color: blue; position: absolute; text-transform: none;`;
                copy.class = "cadeira";
                copy.codigo_obj = `${copy.codigo_obj}-${i + 1}`;
                array.push(copy);
              }
            } else {
              let number = Number(
                seat.identificacao.replace("MESA", "").split("-")[0]
              );
              let metade = Math.ceil(number / 2);

              for (let i = 0; i < number; i++) {
                let copy = JSON.parse(JSON.stringify(seat));
                let splittedStyle = seat.style.split("; ");
                let topStyle = 0;
                let leftStyle = 0;
                let width = 0;
                let height = 0;

                splittedStyle.forEach((style) => {
                  if (style.includes("top"))
                    topStyle = Number(style.split(" ")[1].replace("px", ""));
                  if (style.includes("left"))
                    leftStyle = Number(style.split(" ")[1].replace("px", ""));
                  if (style.includes("width"))
                    width = Number(style.split(" ")[1].replace("px", ""));
                  if (style.includes("height"))
                    height = Number(style.split(" ")[1].replace("px", ""));
                });

                let isLeftSide = i < metade; // Primeira metade vai para a esquerda
                let cadeiraLeft = isLeftSide
                  ? leftStyle + 5
                  : leftStyle + width - 25; // Ajuste no posicionamento
                let cadeiraTop = topStyle + (i % metade) * (height / metade); // Distribui verticalmente

                copy.style = `top: ${cadeiraTop}px; left: ${cadeiraLeft}px; background-color: blue; position: absolute; text-transform: none;`;
                copy.class = "cadeira";
                copy.codigo_obj = `${copy.codigo_obj}-${i + 1}`;
                array.push(copy);
              }
            }
          }
        });
      }
      return array;
    },
  },
  watch: {
    cartProducts() {
      this.removedSeatFunction();
      let cartProd = [];
      this.cartProducts.forEach((product) => {
        product
          .filter((cp) => cp.haveSeat)
          .map((el) => {
            el.codes.forEach((se) => cartProd.push(se));
            return el.codigo_obj;
          });
      });
      if (cartProd.length) {
        cartProd.forEach((el) => {
          let reservedSeat = this.listSeats.filter((el) => el.selecionado);
          if (reservedSeat.length) reservedSeat[0].selecionado = false;
          let cartSeat = document.getElementById(el);
          cartSeat.classList.add("reserved-seat");
        });
      }
    },
  },
  mounted() {
    this.addClassInSelecteds();
  },
  methods: {
    addClassInSelecteds() {
      if (this.cartProducts && this.cartProducts.length) {
        this.cartProducts.forEach((p) => {
          p.forEach((t) => {
            if (t.codes && t.codes.length) {
              t.codes.forEach((c) => {
                var getSeat = document.getElementById(c);
                getSeat.classList.toggle("selected-seat");
              });
            }
          });
        });
      }
    },
    validateUserSeats() {
      let cartProd = [];
      this.cartProducts.forEach((product) => {
        product
          .filter((cp) => cp.haveSeat)
          .map((el) => {
            el.codes.forEach((se) => cartProd.push(se));
            return el.codigo_obj;
          });
      });
      if (cartProd.length) {
        cartProd.forEach((el) => {
          let reservedSeat = this.listSeats.filter(
            (ca) => parseInt(ca.codigo_obj) === parseInt(el)
          );
          reservedSeat[0].reserved = true;
          let cartSeat = document.getElementById(el);
          cartSeat.classList.add("reserved-seat");
        });
      }
    },
    openInfo() {
      this.$store.commit("SET_SELECTED_INFO", true);
    },
    removedSeatFunction() {
      if (this.removedSeat) {
        let seatElement = document.getElementById(this.removedSeat.codigo_obj);
        seatElement.classList.remove("reserved-seat");
        seatElement.classList.remove("selected-seat");
      }
    },
    checkIfDrag() {
      this.timeoutDrag = setTimeout(() => {
        this.isDrag = true;
      }, 150);
    },
    setSeatToSelect(el) {
      this.selectSeat(el.target.id);
    },
    onInit: function (panzoomInstance, id) {
      this.pzx = document.getElementById("panz").offsetWidth;
      this.pzy = document.getElementById("panz").offsetHeight;
      this.panInst = panzoomInstance;
      this.panId = id;
      if (this.$vuetify.breakpoint.mdAndUp) {
        panzoomInstance.moveTo((this.pzx - this.mapSize) / 10, 0);
        panzoomInstance.zoomAbs(0, 0, 0.75);
      } else {
        panzoomInstance.moveTo(0, 0);
        panzoomInstance.zoomAbs(0, 0, 0.5);
      }
      this.mapIsReady = true;
    },
    resetZoom() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.panInst.moveTo(100, 0);
        this.panInst.zoomAbs(0, 0, 0.75);
      } else {
        this.panInst.moveTo(0, 0);
        this.panInst.zoomAbs(0, 0, 0.5);
      }
    },
    onZoomIn() {
      let canvasx = document.getElementById("panz").offsetWidth;
      let canvasy = document.getElementById("panz").offsetHeight;
      this.panInst.smoothZoom(canvasx / 2, canvasy / 2, 1.5);
    },
    onZoomOut: function () {
      let canvasx = document.getElementById("panz").offsetWidth;
      let canvasy = document.getElementById("panz").offsetHeight;
      this.panInst.smoothZoom(canvasx / 2, canvasy / 2, 0.7);
    },
    selectSeat(id) {
      const seat = this.formattedMap.find(
        (test) => parseInt(test.codigo_obj) === parseInt(id)
      );

      if (
        seat &&
        seat.identificacao.includes("Mesa") &&
        !seat.identificacao.includes(";")
      ) {
        let haveSeatsInTable = this.formattedMap.find((el) =>
          el.identificacao.includes(seat.identificacao + ";")
        );
        if (haveSeatsInTable) return;
      }

      if (!seat.reserved) {
        var getSeat = document.getElementById(seat.codigo_obj);
        getSeat.classList.toggle("selected-seat");
      }
      this.$store.commit("SET_SELECTED_SEAT", seat);
    },

    handleShowError(el) {
      let code = el.target.id.includes("-")
        ? el.target.id.split("-")[0]
        : el.target.id;

      let seat = this.formattedMap.find(
        (el) => parseInt(el.codigo_obj) === parseInt(code)
      );

      if (
        !seat.disponivel &&
        seat.codigo_assento &&
        !this.$vuetify.breakpoint.mdAndUp
      ) {
        let namePerClass = "";

        if (seat.class === "camarote") namePerClass = "Camarote";
        else if (seat.class === "cadeira") namePerClass = "Assento";

        this.$store.dispatch("openSnackbar", {
          message: `${namePerClass} ${
            seat.class === "cadeira"
              ? seat.identificacao.replace(";", "-")
              : this.getIdentification(seat)
          } Indisponível`,
          color: "error",
          timeout: 3000,
        });
      }
    },

    getIdentification(seat) {
      const { identificacao } = seat;

      let stringIdentification = String(identificacao);

      let formatted = stringIdentification.replace("Mesa", "");

      if (stringIdentification.includes("Mesa")) {
        if (seat.class === "cadeira") return formatted.split(";").pop();
        else return formatted;
      } else if (stringIdentification.includes("MESA")) {
        if (seat.class === "cadeira") return "";
        else return formatted.split("-")[1];
      }

      return this.getNumberMethod(stringIdentification);
    },
    getNumberMethod(value) {
      if (!value) return "";
      value = value.toString();
      return value.split(";").pop();
    },
    getStyleCircle(index, length, size, topStyle, leftStyle) {
      let div = 360 / length;
      let radius = size / 2;
      let top = Math.sin(div * index * (Math.PI / 180)) * (size / 1.5);
      let left = Math.cos(div * index * (Math.PI / 180)) * (size / 1.5);
      return `left: ${left + leftStyle + radius - 10}px; top: ${
        top + topStyle + radius - 10
      }px;`;
    },
    checkObjectClass(value) {
      if (value.class === "elementoIdent") return "ident-bg";
      if (value.class === "cadeiraObeso") return "obeso";
      if (value.class === "cadeiraDefici2" || value.class === "cadeiraDefici1")
        return "cadeirante";
      if (
        (value.tipo === "*" && !value.disponivel) ||
        (value.tipo === "9" && !value.produto_vinculado)
      )
        return "dot disabled-seat";
      if (value.tipo === "*" || value.tipo === "9") return "dot";
    },
    validateStyle(value) {
      let style = value.style
        .replaceAll("#pst", "position")
        .replaceAll("#abs", "absolute")
        .replaceAll("#mr", "margin-right")
        .replaceAll("#mt", "margin-top")
        .replaceAll("#ml", "margin-left")
        .replaceAll("#tt", "text-transform")
        .replaceAll("#up", "uppercase")
        .replaceAll("#fs", "font-size")
        .replaceAll("#bc", "background-color")
        .replaceAll("#lh", "line-height")
        .replaceAll("#ls", "letter-spacing");

      let seat = this.formattedMap.find(
        (el) => parseInt(el.codigo_obj) === parseInt(value.codigo_obj)
      );
      if (
        seat &&
        seat.identificacao.includes("Mesa") &&
        !seat.identificacao.includes(";")
      ) {
        let haveSeatsInTable = this.formattedMap.find((el) =>
          el.identificacao.includes(seat.identificacao + ";")
        );
        if (haveSeatsInTable) style += " cursor: default;";
      }

      if (value.tipo !== "*" && value.tipo !== "9") return style;

      if (
        (value.tipo === "*" && !value.disponivel) ||
        (value.tipo === "9" && (!value.produto_vinculado || !value.disponivel))
      ) {
        style += " background-color: #B0B6BF;";
      } else if (value.cor && value.disponivel) {
        style += ` background-color: ${value.cor};"`;
      } else style += " background-color: #1976d2;";

      return style;
    },

    getSpecificStyle(style, type) {
      let splittedStyle = style.split("; ");
      let specificStyle = null;
      splittedStyle.forEach((s) => {
        if (s.includes(type) && !specificStyle) specificStyle = s.split(" ")[1];
      });
      return String(specificStyle).replace(";", "");
    },
  },
};
</script>

<style scoped>
#seatmap {
  width: 150vw;
  height: 100vh;
  position: relative;
  overflow: visible;
}
.seat-header {
  height: 60px;
}
.dot {
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
}
.cadeirante {
  cursor: pointer;
  height: 20px;
  width: 43px;
  margin: 0px 5px;
  background-color: #1976d2;
  border-radius: 4px;
  display: inline-block;
}
.obeso {
  cursor: pointer;
  height: 20px;
  width: 27px;
  background-color: #1976d2;
  border-radius: 3px;
  display: inline-block;
}
.selected-seat {
  background-color: #10e79f !important;
}
.seat-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
  color: white;
  font-size: 9px;
}
.seat-cadeirante {
  color: white;
  font-size: 18px;
}
.selected-seat .seat-cadeirante {
  color: #192b46 !important;
}
.selected-seat .seat-number {
  color: #192b46 !important;
}
.identificacao {
  display: inline-block;
  background-color: #f1f2f3 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
  font-weight: bold;
  font-size: 12px;
  line-height: 23px;
  letter-spacing: 0.25px;
  color: #626973;
}
.ident-bg {
  background-color: #f1f2f3 !important;
}
.palco {
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
.tooltip-text-title {
  color: white;
  font-weight: 900;
  font-size: 18px;
}
.tooltip-text {
  color: white;
  font-size: 14px;
  font-weight: 450;
  line-height: 20px;
}
.add-remove-button {
  height: 24px !important;
  width: 24px !important;
  margin: 0;
  border-width: 2px !important;
  justify-content: center;
}

.add-remove-button__icon {
  font-size: 19px !important;
  font-weight: bold;
}
.seat-header-text {
  font-size: 14px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #838d9b;
  vertical-align: middle;
}
.seat-header-text-mb {
  font-size: 10px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #838d9b;
  vertical-align: middle;
}
.seat-header-subtitle-text {
  font-size: 14px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #1976d2;
  vertical-align: middle;
}
.recenter-btn {
  width: 23px !important;
  height: 23px !important;
}
.selecting {
  pointer-events: none;
}
.disabled-seat {
  cursor: move;
}

.reserved-seat {
  background-color: #10e79f !important;
}
.reserved-seat .seat-number {
  color: #192b46 !important;
}
.reserved-seat .theme--light.v-icon {
  color: #192b46 !important;
}
.click-btn {
  cursor: pointer;
}
</style>

<style>
.ident-palco p {
  color: white !important;
  margin-bottom: 0px !important;
  font-size: 12px !important;
  font-weight: bold;
}
</style>
